import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context7; _forEachInstanceProperty(_context7 = ownKeys(Object(source))).call(_context7, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { ENTITIES, STATUS, LISTS, ITEMS, ETAG } from './constants';
import { defaultListState, defaultItemState } from './defaults';
import { createEtag } from './etags';
import { get } from 'lodash';
/**
 * Return default state for whatever record type we have
 * @param  {string} type
 * @return {Object}
 */

function getDefaultState(type) {
  switch (type) {
    case LISTS:
      return defaultListState;

    case ITEMS:
      return defaultItemState;

    default:
      return {};
  }
}
/**
 * Set loading status on specific record or list
 * @param {Object} state
 * @param {string} group
 * @param {string} id
 * @param {string} status
 */


function setEntityStatus(state, group, id, status) {
  var _context, _objectSpread2;

  var entityState = get(state, _concatInstanceProperty(_context = "".concat(group, ".")).call(_context, id));

  if (entityState && entityState[STATUS] === status) {
    return state;
  }

  var groupState = entityState || getDefaultState(group);
  var etag = createEtag();
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, group, _objectSpread(_objectSpread({}, state[group]), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, groupState), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, STATUS, status), _defineProperty(_objectSpread2, ETAG, etag), _objectSpread2))))));
}

export function setEntityListStatus(state, id, status) {
  return setEntityStatus(state, LISTS, id, status);
}
export function setEntityItemStatus(state, id, status) {
  return setEntityStatus(state, ITEMS, id, status);
}

function getEntityStatus(state, type, id, group) {
  var _context2, _context3, _context4, _context5;

  return get(state, _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "".concat(ENTITIES, ".")).call(_context5, type, ".")).call(_context4, group, ".")).call(_context3, id, ".")).call(_context2, STATUS));
}

export function getEntityListStatus(state, type, id) {
  return getEntityStatus(state, type, id, LISTS);
}
export function getEntityItemStatus(state, type, id) {
  return getEntityStatus(state, type, id, ITEMS);
}